import $ from 'jquery';
import {Loader} from "@googlemaps/js-api-loader";

let detEl = $('.specialist-detail');
let map;
let markers = [];
let infowindows = [];
let primaryMarkerIdx = false;
const loader = new Loader({
    apiKey: "AIzaSyDcrKy0_Xl4vw4R0gBMxfAxmQBH6XdtoEc",
    version: "weekly",
    libraries: ["places", "geometry"]
});

$(function () {
    if (detEl.length > 0) {
        loader.load().then(() => {
            map = new google.maps.Map(detEl.find('.specialist-detail__contact_map')[0], {
                zoom: 7,
                center: {lat: 49.8175, lng: 15.4730}
            });
            renderMap(detEl);
            bindSelectBox(detEl);
        });

        if ($('.alert').length) {
            $('html, body').animate({
                scrollTop: $('.specialist-detail__contact:first').offset().top
            }, 1000);
        }
    }
});

const bindSelectBox = (element) => {
    const select = element.find('#frm-address_email');
    select.on('change', function () {
        const selectedOption = $(this).children('option:selected');
        const textSplit = selectedOption.val().split('_jVq0YSpp_');
        const lat = parseFloat(textSplit[2]);
        const lng = parseFloat(textSplit[3]);
        $.each(markers, (key, marker) => {
            if (!isNaN(lat) && !isNaN(lng) && marker.position.lat() === lat && marker.position.lng() === lng) {
                marker.setIcon({url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png"});
            } else if (primaryMarkerIdx !== false && key === primaryMarkerIdx) {
                    marker.setIcon({url: "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"});
            } else {
                marker.setIcon({url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png"});
            }
        });
    });
};

const renderMap = async (element) => {
    const title = $('#specialist-detail__infoblock_row_name').html().trim();
    element.find('.specialist-detail__infoblock_row__address').each((key, address_node) => {
        const address = $(address_node);
        const street = $(address.find('.specialist-detail__address-street')[0]).text();
        const lat = parseFloat($(address.find('.address-lat')[0]).attr('value'));
        const lng = parseFloat($(address.find('.address-lng')[0]).attr('value'));
        const email = $(address.find('.address-email')[0]).attr('value');
        const phone = $(address.find('.address-phone')[0]).attr('value');
        const markerImg = "http://maps.google.com/mapfiles/ms/icons/" + ($(address).hasClass('primary-location') ? "yellow" : "green") + "-dot.png";
        if ($(address).hasClass('primary-location')) {
            primaryMarkerIdx = key;
        }
        const contentString =
            '<div class="marker-popup">' +
            '<h4 class="marker-popup__header">' + title + '</h4>' +
            '<div class="marker-popup__text">' +
            '<p class="marker-popup__text__location">' + street + '</p>' +
            (phone ? '<p class="marker-popup__text__phone">' + phone + '</p>' : '') +
            (email ? '<p class="marker-popup__text__email">' + email + '</p>' : '') +
            "</div>" +
            "</div>";
        const infowindow = new google.maps.InfoWindow({
            content: contentString,
        });
        const marker = new google.maps.Marker({
            map,
            position: {lat: lat, lng: lng},
            title: title,
            clickable: true,
            icon: {
                url: markerImg
            }
        });
        marker.addListener("click", () => {
            $.each(infowindows, (key, infowin) => {
                infowin.close();
            });
            infowindow.open(map, marker);
        });
        markers.push(marker);
    });
    if (markers.length) {
        var bounds = new google.maps.LatLngBounds();
        $.each(markers, (key, marker) => {
            bounds.extend(marker.position);
        });
        if (markers.length > 1) {
            map.fitBounds(bounds);
        } else {
            map.setCenter(markers[0].position);
            map.setZoom(12);
        }
    } else {
        map.setCenter({lat: 49.8175, lng: 15.4730});
        map.setZoom(7);
    }
}